import { typedQueryClient, useTypedQuery } from "hooks";
import { DealersDashboardQueryKeys } from "modules/DealersDashboard/queryKeys";

import type { DealersDashboardFilter } from "modules/DealersDashboard/queryKeys";
import type { AtLeastOne } from "utils/type";

export const useGetDealersDashboardFilters = () =>
  useTypedQuery({
    queryKey: DealersDashboardQueryKeys.filters,
    initialData: { term: "", status: null, areLocationsExpanded: false }
  });

export const setDealersDashboardFilters = (newFilters: AtLeastOne<DealersDashboardFilter>) =>
  typedQueryClient.setQueryData(DealersDashboardQueryKeys.filters, prev => (prev ? { ...prev, ...newFilters } : prev));
